module.exports = __webpack_public_path__ + "static/logistics-tracking-notification@3x-fd90dccfbe4cd5e22e75bf5e60cf49e9.png";